export default __webpack_public_path__ + "static/media/fae.b79c2c37.png";